import React from 'react'
import Icon from '../../../elementals/icon'
import ListingBadge, { BADGE_MODE, BADGE_ORDER_PRIORITY } from './base'

class RemoteBidBadge extends ListingBadge {
  static title = 'Remote Bid'

  static summary = ''

  static titleIcon = (
    <Icon.Group>
      <Icon name='mobile-android' iconStyle='light' size='large' />
      <Icon
        name='gavel'
        style={{
          fontSize: '1em',
          top: '17%',
          left: '12%',
          transform: 'scaleX(-1)',
          textShadow: '-1px -1px 0px white, 1px 1px 0px white',
        }}
      />
    </Icon.Group>
  )

  static content = null

  static renderPriority = BADGE_ORDER_PRIORITY.FIRST

  static shouldBeIncluded(listing, badgeMode) {
    const {
      is_remote_bid_enabled,
      is_remote_before_and_during_auction_enabled,
    } = listing.listing_summary || {}
    const remoteBidEnabled =
      is_remote_bid_enabled || is_remote_before_and_during_auction_enabled

    return badgeMode === BADGE_MODE.CONDENSED && remoteBidEnabled
  }
}

export default RemoteBidBadge
